$(document).ready(function() {
	// Open and close content toggles
	$('.language-block__toggle').on('click', function() {

		// Trigger a window resize so that dimensions of child elements
		// hidden on page load can be recalculated, e.g. a Slick slider
		// within a `display: none;` content toggle div
		$(window).trigger('resize');

		$(this).toggleClass('language-block__toggle--active');

		var target = $(this).data( 'target' );
		$('.distributors-content[data-content=' + target + ']').toggleClass('distributors-content--active');

	});
});

var toggleButtons = document.querySelectorAll('.language-block__toggle');

if ( toggleButtons.length > 0 ) {
	for (var i = 0; i < toggleButtons.length; i++) {
		toggleButtons[i].addEventListener('click', function(e) {
			var target = this.getAttribute('data-target');
			var el = document.querySelector('.distributors-toggle-content[data-content="' + target + '"]');
			if (el.getAttribute('data-active') !== 'true' ) {
				el.setAttribute('data-active', 'true');
				var elH = getHeight(el);
				window.setTimeout(function() {
					el.style.height = elH+'px';
				}, 100);
			} else {
				el.setAttribute('data-active', 'false')
				el.style.height = '0';
			}
		});
	}
}

function getHeight(el) {
    el.style.height = 'auto';
    elHeight = el.offsetHeight;
    el.style.height = '0';
    return elHeight;
}